import * as Mui from "@mui/material";
import { customTheme } from "../../../../../config/theme/MuiTheme";
import useOperationTranslation from "../../../hooks/useOperationTranslation";

interface Props {
    date: string,
    user: string,
    message: string
}

const ActionsCard = (props: Props) => {
    const t = useOperationTranslation();

    return(   
        <Mui.Box mt={2}>
            <Mui.Card> 
                <Mui.CardContent>
                    <Mui.Typography textAlign="end" variant="h6">
                        {props.date}
                    </Mui.Typography> 

                    <Mui.Grid container spacing={1}>
                        <Mui.Grid item xs="auto" >
                            <Mui.Typography>
                                {t("damageForm.details.action.actionCard.user")}        
                            </Mui.Typography>                
                        </Mui.Grid>

                        <Mui.Grid item>
                            <Mui.Typography variant="h6">
                                {props.user}
                            </Mui.Typography>
                        </Mui.Grid>          
                    </Mui.Grid>  

                    <Mui.Typography variant="body1" color={customTheme.palette.grey[600]}>
                        {props.message}
                    </Mui.Typography>               
                </Mui.CardContent>   
            </Mui.Card>
        </Mui.Box>
    )
}
export default ActionsCard;